
export interface IMenuParametro {
	codEmpresa: number;
	codUsuario: string;
}

export class MenuParametro implements IMenuParametro {
	constructor(
		public codEmpresa: number,
		public codUsuario: string
	){
		this.codEmpresa = codEmpresa;
		this.codUsuario = codUsuario;
	}
}
